import AuthWall from '../../../../components/auth-wall';
import '../networkAnalysisPage.scss';
import {observer} from 'mobx-react';
import {Navigate} from 'react-router-dom';
import RevisionIdSelector from '../../components/revision-id-selector';
import Tabs from '../../components/tabs/tabs';
import useReportsPageController from './useReportsPageController';
import ReportsPageTabView from './components/ReportsPageTabView';
import Export from './components/Export';

function ReportsPage() {

    const {
        data: {
            rosterId,
            isExporting,
            selectedViewType,
            exportMenuItems,
            activeTab,
            currentViewTypes,
            tabs,
            generateReportPath
        },
        methods: {
            onSelectedViewTypeChange,
            onActiveTabChange,
        }
    } = useReportsPageController();

    if (!rosterId) return <Navigate to="/network-optimization/my-files" replace />;

    return (
        <AuthWall>
            <div className="network-analysis-page pt-5 bg-white border-b border-background-gray-200 items-center" data-testid="reports-page-container">
                <div className="flex justify-between items-start w-full px-12">
                    <h1 className="m-0 text-[28px] font-normal font-inherit leading-none" data-testid="reports-page-title">Reports</h1>
                    <Export
                        isExporting={isExporting}
                        menuItems={exportMenuItems}
                    />
                </div>
                <div className="flex items-center w-full py-4 px-12 pb-2" data-testid="revision-id-selector">
                    <RevisionIdSelector rosterId={rosterId} />
                </div>
                <Tabs
                    tabs={tabs.map(tab => {
                        return {
                            ...tab,
                            content: (
                                <ReportsPageTabView
                                    selectedViewType={selectedViewType}
                                    onSelectedViewTypeChange={onSelectedViewTypeChange}
                                    activeTab={activeTab}
                                    currentViewTypes={currentViewTypes}
                                    generateReportPath={generateReportPath}
                                />
                            )
                        };
                    })}
                    variant="default"
                    onClick={onActiveTabChange}
                />
            </div>
        </AuthWall>
    );
}

export default observer(ReportsPage);
